<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.title" placeholder="标题"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getInfos">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection"  min-width="40">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="title" label="标题" width="200" >
			</el-table-column>
			<el-table-column prop="image_url" label="图片" width="200" >
			   <template slot-scope="scope">
			      <img v-if="scope.row.image_url" :src="scope.row.image_url" class="avatar">
			   </template>
			</el-table-column>


			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button type="primary" size="small"  plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleDel(scope.$index, scope.row)">删除</el-button>
					<el-button type="primary" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleSend(scope.$index, scope.row)">发布</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?true:false"  plain @click="handleCancel(scope.$index, scope.row)">撤销</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>--></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="cancelSubmit"  size="small" >
			<el-form :model="editForm"    label-width="120px" :rules="editFormRules" ref="editForm">  			
				  

				   	<el-form-item label="产品组" prop="app_group_tmp">
					 <el-select v-model="editForm.app_group_tmp" clearable multiple  placeholder="请选择" @change="appGroupChange"  @visible-change="visibleChange" @remove-tag="removeTag" style="width:400px;">
                        <el-option  v-for="(item,index) in appgroups" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>


				   	<el-form-item label="产品" prop="app_id_tmp">
					 <el-select v-model="editForm.app_id_tmp" clearable multiple  placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in apps"  :key="index"  :label="item.app_name"  :value="item.id"> </el-option>
                     </el-select>
				   </el-form-item>				  		
				
				<el-form-item label="标题" prop="title">
					<el-input v-model="editForm.title" auto-complete="off"></el-input>
				</el-form-item>

 			<el-form-item label="上传图片" >
				<el-upload
					class="avatar-uploader"
					:action="imageupload"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload">
					<img v-if="editForm.image_url" :src="editForm.image_url" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>


				<el-form-item label="android下载地址" prop="android_download_url"  :rules="[{ required: true, message: '请输入android下载地址', trigger: 'blur' },{ type: 'url', message: '请输入正确的网址', trigger: 'blur' }]">
				     <el-input v-model="editForm.android_download_url" auto-complete="off" ></el-input>
				</el-form-item>

				<el-form-item label="ios下载地址" prop="ios_download_url"   :rules="[{ required: true, message: '请输入ios下载地址', trigger: 'blur' },{ type: 'url', message: '请输入正确的网址', trigger: 'blur' }]">
				     <el-input v-model="editForm.ios_download_url" auto-complete="off" ></el-input>
				</el-form-item>

				<el-form-item label="产品介绍地址" prop="product_url" >
				     <el-input v-model="editForm.product_url" auto-complete="off" ></el-input>
				</el-form-item>

	          
                  
              <el-form-item label="">					
					 <el-checkbox v-model="editForm.top">置顶</el-checkbox>					
			  </el-form-item>	
		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getAdListPage,addAd,editAd, removeAd,batchRemoveAd,getAppGroup,getApp,upload,imgDel,imgsDel,runType,adRelease,adUnRelease } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 
	export default {
		data() {
			return {
				filters: {
					title: ''
				},
			    old_image_url:'',
				imageupload:upload+'?runType='+runType+'&type=1&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				selectchangeflag:0,
				appgroups:[],
				apps:[],					
				infos: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {					
					title:[ {  required: true, message: '请输入标题', trigger: 'blur' }]					
				},			
				
				//编辑界面数据
				editForm: {
					id: 0,			
					title:'',
					ios_download_url:'',
					android_download_url:'',				
					product_url:'',
					image_url:'',				
					app_group_tmp:[],
					app_id_tmp:[],
					top:false				 

             
				},
				
				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			cancelSubmit:function(){               
					
			   if (this.editForm.image_url!="" && (this.editForm.image_url!=this.old_image_url))
				{			
					var surl=this.editForm.image_url.split("/");
					this.imgDel(surl[surl.length-1],false);	
				}	
				
				this.old_image_url="";
				this.editForm.image_url="";
				
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
			},
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},
	  imgDel(filename,Multiple){
                    
					var imgUrl=imgDel;
		            if (Multiple)
					{
                         imgUrl=imgsDel;
					}
      				this.$http.jsonp(imgUrl,{params: {CurrentUserID:CurrentUserID,Session:Session,fileName:filename,type:1,runType:runType}}).then(
						function(res){                         
							if (res.data.result_code!=200)
							{                           
								this.$message({
								message:'删除文件错误',
								type: 'error'
								});
							}
						},
						function(res)
						{
							this.$message({
									message:'删除文件错误',
									type: 'error'
									});
							
						});

	  },
	  handleRemove(file, fileList) {    
		

		   
        
      },

     handleAvatarSuccess(res, file) {
       // this.imageUrl = URL.createObjectURL(file.raw);
	   //file.name=res.file_name;
	   //file.url=res.file_url;
	 
	    if (this.editForm.image_url!="" && (this.editForm.image_url!=this.old_image_url))
		{			
			var surl=this.editForm.image_url.split("/");
             this.imgDel(surl[surl.length-1],false);	
		}
		this.$set(this.editForm,"image_url",res.file_url);
      },

    beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },

			visibleChange(val)
			  {
                 if(val)
				 {
                      this.selectchangeflag=1;
				 }else{
                       this.selectchangeflag=0;
				 }
			  },
			  removeTag(val)
			  {
                  this.selectchangeflag=1;
			  },
				appGroupChange(val)
				{
                   
					if (this.selectchangeflag==0) return;
					this.apps=[];
					this.editForm.app_id_tmp=[];
					if (val==''  ) return;
				   				
				    this.getApp(val.join(','));
				   
				},

				getApp(val){
					this.$http.jsonp(getApp,{params: {CurrentUserID:CurrentUserID,Session:Session,appGroup:val }}).then(
										function(res){                         
										if (res.data.result_code==200)
										{						
											this.apps=res.data.apps;
											if (this.apps.length==0)
											{
												this.editForm.app_id_tmp=[];
											}
										}
										else{                           
											this.$message({
											message:'获取产品错误',
											type: 'error'
											});
										}
									

										},
										function(res)
										{
											this.$message({
													message:'获取产品错误',
													type: 'error'
													});
											
										});

				},
	
		   getAppGroup(){
             	 this.$http.jsonp(getAppGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						this.appgroups=res.data.appgroups;					
					}
					else{                           
						this.$message({
						message:'获取产品组错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取产品组错误',
								type: 'error'
								});
						
					});


			},
		
			getInfos() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					title: this.filters.title,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getAdListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.adlist.total;
					         this.infos = res.data.adlist.infos;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},


			//发布
			handleSend: function (index, row) {
				if (row.sender!=null)
				{
                    this.$message({
                                message:'已发布！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认发布吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(adRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '发布成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//撤销发布
			handleCancel: function (index, row) {
				if (row.sender==null)
				{
                    this.$message({
                                message:'未发布，不能撤销！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认撤销吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(adUnRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '撤销成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:res.data.error,
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };


                   this.$http.jsonp(removeAd, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;

				
				this.selectchangeflag=0;
				
				this.editForm = Object.assign({}, row); 

				

				this.editForm.top=this.editForm.top>0?true:false; 	
                this.editForm.app_group_tmp=JSON.parse(row["app_group_tmp"]);
				this.editForm.app_id_tmp=JSON.parse(row["app_id_tmp"]);	
                this.old_image_url=this.editForm.image_url;
				this.getApp(this.editForm.app_group_tmp.join(','));
				//this.$set(this.editForm,"jump_params_tmp",JSON.parse(row["jump_params_tmp"]));
               //this.$set(this.editForm,"img_url_tmp",JSON.parse(row["img_url_tmp"]));

				this.editFormVisible = true;
      			
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.old_image_url="";
				this.editFormVisible = true;				
			    
				this.editForm = {
					id: 0,			
					title:'',
					ios_download_url:'',
					android_download_url:'',				
					product_url:'',
					image_url:'',
					app_group_tmp:[],
					app_id_tmp:[],
					top:false	
				};
				
                if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }		
				
			},
			//编辑
			editSubmit: function () {

				if (this.editForm.app_group_tmp.length==0)
				{
				    this.$message({
                                message:'请选择产品组',
                                type: 'error'
                              });
							  return;
			     }
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							         

							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;						
							para["app_group_tmp"]=JSON.stringify(this.editForm.app_group_tmp);
							para["app_id_tmp"]=JSON.stringify(this.editForm.app_id_tmp);
						               
					


			   let infoUrl=	addAd;			  
               if (this.formStatus==1)
			   {
                  infoUrl=editAd;
			   }
                this.$http.jsonp(infoUrl, {params: para}).then(
				//this.$http.post(infoUrl, para,{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {		
							// this.$refs['editForm'].resetFields();	
							this.editForm = {
								id: 0,			
								title:'',
								ios_download_url:'',
								android_download_url:'',				
								product_url:'',
								image_url:'',
								app_group_tmp:[],
								app_id_tmp:[],
								top:false	
							};	

                              if (this.old_image_url!="")
							  {
								  var surl=this.old_image_url.split("/");
                                 this.imgDel(surl[surl.length-1],false);						     
							     this.old_image_url="";   
							  } 
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getInfos();
                            
                         }
                         else{                           
                               this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };
            

                   this.$http.jsonp(batchRemoveAd, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 	
			
			this.getAppGroup();
			
			this.getInfos();
		
           
 	        
			
		}
	}

</script>

<style scoped>
.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
	width: 178px;
    height: 178px;
}


  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// pushad.vue?09f8c722